import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Moon } from "lucide-react";

function formatCountdown(ms) {
  if (ms <= 0) return "now";
  const s = Math.floor(ms / 1000);
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  if (h > 0) return `${h}h ${m}m`;
  if (m > 0) return `${m}m ${sec}s`;
  return `${sec}s`;
}

export default function BloodMoonCountdown() {
  const [event, setEvent] = useState(null);
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const refresh = () => api.eventCurrent().then(setEvent).catch(() => {});
    refresh();
    const t = setInterval(refresh, 60000);
    const tick = setInterval(() => setNow(Date.now()), 1000);
    return () => { clearInterval(t); clearInterval(tick); };
  }, []);

  if (!event) return null;

  // Always visible — during active event shows "ends in", otherwise "next in".
  const target = event.active
    ? (event.ends_at ? new Date(event.ends_at).getTime() : null)
    : (event.next_start ? new Date(event.next_start).getTime() : null);
  if (!target) return null;
  const remaining = target - now;
  const active = event.active;

  return (
    <div
      data-testid="blood-moon-countdown"
      className="px-3 py-1 border-b border-[#262626] flex items-center justify-between text-[10px]"
      data-active={active ? "1" : "0"}
    >
      <div className="flex items-center gap-2 text-[#8c8c8c]">
        <Moon className={`w-3 h-3 ${active ? "text-[#E33333] ember-pulse" : "text-[#8A0303]"}`} strokeWidth={1.5} />
        <span className="font-heading tracking-[0.25em] uppercase">
          {active ? "Blood Moon Active" : "Next Blood Moon"}
        </span>
      </div>
      <span className="font-mono text-[#E5C34A]" data-testid="blood-moon-time">
        {active ? "ends in" : "in"} {formatCountdown(remaining)}
      </span>
    </div>
  );
}
